import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { useLang } from "@/lib/i18n";

export default function Privacy() {
  const { t, lang } = useLang();
  return (
    <LegalLayout title={t("legal.privacy.title")} updated={t("legal.privacy.updated")} testid="privacy-page" path="/datenschutz">
      {lang === "de" ? <De /> : <En />}
    </LegalLayout>
  );
}

const De = () => (
  <>
    <h2>1. Verantwortlicher</h2>
    <p>
      Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br />
      X10 Management GmbH<br />
      Herner Str. 299, 44809 Bochum, Deutschland<br />
      E-Mail: <a href="mailto:datenschutz@x10management.de">datenschutz@x10management.de</a>
    </p>

    <h2>2. Erhebung allgemeiner Informationen beim Besuch unserer Website</h2>
    <p>
      Bei jedem Zugriff auf unsere Website werden durch unseren Hosting-Provider
      automatisch Informationen erfasst (Server-Logfiles): Browsertyp/-version,
      Betriebssystem, Referrer-URL, Hostname des zugreifenden Rechners, Uhrzeit und
      anonymisierte IP-Adresse. Diese Daten werden nicht mit anderen Datenquellen
      zusammengeführt und ausschließlich zur Sicherstellung des reibungslosen Betriebs
      sowie zur Verbesserung unseres Angebots ausgewertet (Art. 6 Abs. 1 lit. f DSGVO).
    </p>

    <h2>3. Kontaktformular</h2>
    <p>
      Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben
      inkl. der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage
      und für den Fall von Anschlussfragen bei uns gespeichert. Rechtsgrundlage ist
      Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) sowie Art. 6 Abs. 1 lit. b DSGVO
      (Anbahnung eines Vertragsverhältnisses).
    </p>

    <h2>4. Cookies</h2>
    <p>
      Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den
      Betrieb der Seite erforderlich sind. Es findet kein Tracking und keine Analyse
      durch Drittanbieter statt. Die Speicherung erfolgt auf Grundlage von § 25 Abs. 2
      Nr. 2 TTDSG.
    </p>

    <h2>5. Eingebettete Inhalte (Google Maps)</h2>
    <p>
      Wir binden auf unserer Website eine Karte von Google Maps ein. Beim Aufruf der
      Kontaktseite werden Daten an Google übertragen (IP-Adresse, Browserinformationen).
      Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
      Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
      benutzerfreundlicher Darstellung).
    </p>

    <h2>6. Ihre Rechte</h2>
    <p>Sie haben jederzeit das Recht auf:</p>
    <ul>
      <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
      <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
      <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
      <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
      <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
      <li>Widerspruch (Art. 21 DSGVO)</li>
      <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
    </ul>

    <h2>7. Beschwerderecht</h2>
    <p>
      Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren. Zuständig ist
      die Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen
      (LDI NRW), Kavalleriestraße 2-4, 40213 Düsseldorf.
    </p>

    <h2>8. Speicherdauer</h2>
    <p>
      Personenbezogene Daten werden nur so lange gespeichert, wie es zur Erfüllung des
      jeweiligen Zwecks erforderlich ist oder gesetzliche Aufbewahrungsfristen es
      vorschreiben.
    </p>

    <h2>9. SSL-Verschlüsselung</h2>
    <p>
      Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
      vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung.
    </p>
  </>
);

const En = () => (
  <>
    <h2>1. Controller</h2>
    <p>
      Controller within the meaning of the GDPR:<br />
      X10 Management GmbH<br />
      Herner Str. 299, 44809 Bochum, Germany<br />
      Email: <a href="mailto:datenschutz@x10management.de">datenschutz@x10management.de</a>
    </p>

    <h2>2. Server logs</h2>
    <p>
      Each access to our website automatically generates server log files (browser type/version, operating system, referrer URL, hostname, time, anonymised IP). The legal basis is Art. 6 (1) (f) GDPR.
    </p>

    <h2>3. Contact form</h2>
    <p>
      If you contact us via the contact form, the information you provide is stored for processing your request. Legal bases are Art. 6 (1) (a) GDPR (consent) and (b) (pre-contractual measures).
    </p>

    <h2>4. Cookies</h2>
    <p>
      This website only uses technically necessary cookies. No third-party tracking or analytics. Storage is based on § 25 (2) No. 2 TTDSG.
    </p>

    <h2>5. Embedded content (Google Maps)</h2>
    <p>
      We embed a Google Maps map. Provider: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland. Legal basis: Art. 6 (1) (f) GDPR.
    </p>

    <h2>6. Your rights</h2>
    <p>You have the right to access, rectify, erase, restrict, port, object, and withdraw consent.</p>

    <h2>7. Right to lodge a complaint</h2>
    <p>You may complain to a supervisory authority — State Commissioner for Data Protection and Freedom of Information North Rhine-Westphalia (LDI NRW), Kavalleriestraße 2-4, 40213 Düsseldorf.</p>

    <h2>8. Retention period</h2>
    <p>Personal data is stored only as long as necessary or required by law.</p>

    <h2>9. SSL encryption</h2>
    <p>This site uses SSL/TLS encryption for security.</p>
  </>
);
